export const PocActionsMode = {
  Full: 'full',
  DownloadOnly: 'downloadOnly',
  Dropdown: 'dropdown',
} as const;

export type PocActionsMode =
  (typeof PocActionsMode)[keyof typeof PocActionsMode];

export const POC_SCRIPT_ACTION_KEYS = {
  Generate: 'generatePocScriptButton',
  Regenerate: 'regeneratePocScriptButton',
  Download: 'downloadPocScriptButton',
  Delete: 'deletePocScriptButton',
} as const;

export type PocScriptActionKey =
  (typeof POC_SCRIPT_ACTION_KEYS)[keyof typeof POC_SCRIPT_ACTION_KEYS];

export const POC_SCRIPT_DROPDOWN_ORDER: PocScriptActionKey[] = [
  POC_SCRIPT_ACTION_KEYS.Download,
  POC_SCRIPT_ACTION_KEYS.Regenerate,
  POC_SCRIPT_ACTION_KEYS.Generate,
  POC_SCRIPT_ACTION_KEYS.Delete,
];
